import { Html } from "@react-three/drei";
import { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import * as THREE from "three";

const DimensionLabelComponent = forwardRef(({
  params,
  position,
  label,
  visible,
  isMobile,
  isSmall,
  inverse = false,
  distanceScale = 0.8
  // offsetDirection,
}, ref) => {
  const htmlRef = useRef(null);
  const labelDivRef = useRef(null);
  
  // Store position and text in state - we'll update these directly via imperative handle
  const [currentPosition, setCurrentPosition] = useState(position || new THREE.Vector3());
  const [currentText, setCurrentText] = useState(label || '');

  // Sync props to state when they change (for initial render)
  useEffect(() => {
    if (position) {
      setCurrentPosition(position);
    }
    if (label !== undefined) {
      setCurrentText(label);
    }
  }, [position, label]);

  // Expose methods to update position and text directly
  useImperativeHandle(ref, () => ({
    updatePosition: (newPosition) => {
      // Update position state - this will trigger a re-render but it's minimal
      // The Html component will update the CSS2DObject position
      if (newPosition) {
        setCurrentPosition(newPosition);
      }
    },
    updateText: (newText) => {
      // Update text state
      if (newText !== undefined) {
        setCurrentText(newText);
      }
    },
    getObject: () => htmlRef.current
  }), []);

  return (
    <Html
      ref={htmlRef}
      position={currentPosition}   
      zIndexRange={[5, 0]}   
      center
      occlude
      style={{ opacity: visible ? 1 : 0, transition: "opacity 0.25s", color: params.labelColour }}
    >      
      <div
        ref={labelDivRef}
        className={
          isSmall || isMobile
            ? inverse
              ? "modelviewer-label-small-inverse"
              : "modelviewer-label-small"
            : inverse? "modelviewer-label-inverse" : "modelviewer-label"
        }
      >
        {currentText}
      </div>
    </Html>
  );
});

DimensionLabelComponent.displayName = 'DimensionLabel';
export const DimensionLabel = DimensionLabelComponent;
